"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.castModel = exports.ModelSpecSchema = void 0;
var ajv_1 = __importDefault(require("ajv"));
var entity_1 = require("./entity");
var relation_1 = require("./relation");
exports.ModelSpecSchema = {
    type: "object",
    properties: {
        id: { type: "integer" },
        rev: { type: "integer" },
        tenant: { type: "string" },
        entities: { type: "array", items: entity_1.EntitySpecSchema },
        relations: { type: "array", items: relation_1.RelationSpecSchema },
    },
    required: ["id", "rev", "tenant", "entities", "relations"],
};
var ajv = new ajv_1.default();
var validate = ajv.compile(exports.ModelSpecSchema);
// Cast an object of ModelSpec
exports.castModel = function (object) {
    var valid = validate(object);
    if (!valid)
        throw new Error(JSON.stringify(validate.errors));
    var cast = object;
    return {
        id: cast.id,
        rev: cast.rev,
        tenant: cast.tenant,
        entities: cast.entities.map(function (ent) { return new entity_1.EntitySpec(ent); }),
        relations: cast.relations.map(function (rel) { return new relation_1.RelationSpec(rel); }),
    };
};
